import { useEffect, useState } from "react";
import { useAuthStore } from "../../store/auth.store";
import { useSoldSNStore } from "../..//store/soldsn.store";
import { useCompanies } from "../../hook/partner/soldsncompanies.partner.hook";
import { useSNList } from "../../hook/partner/soldsnlist.partner.hook";
import { Accordion, Modal, Nav } from "react-bootstrap";
import { NavLink } from "react-router";
import { useTranslation } from "../../hooks/useTranslation";

export default function SoldSNCompanies({ letter }) {
  const { t } = useTranslation();
  const token = useAuthStore((state) => state.token);
  const companiesMutation = useCompanies();
  const snlistMutation = useSNList();
  const companies = useSoldSNStore((state) => state.companies);
  const snList = useSoldSNStore((state) => state.snList);
  const [company_id, setCompanyId] = useState();

  const [showSN, setShowSN] = useState(false);

  const fullName = (prod) => {
    return (
      <>
        {prod.product.product_family + ": " + prod.product.name}{" "}
        <span
          className={
            "badge badge-secondary me-3 mb-3 badge-vendor-" +
            prod.product.vendor_id
          }
        >
          {prod.product.vendor_name}
        </span>
        <span className="badge badge-info badge-outline">
          {prod.product.sku}
        </span>
      </>
    );
  };

  useEffect(() => {
    if (companies) {
      setCompanyId(companies[0]?.company_id);
    }
  }, [token, companies]);

  useEffect(() => {
    if (token) {
      companiesMutation.mutate({ token, letter });
    }
  }, [token, letter]);

  useEffect(() => {
    console.log("nahraj firmu");
    if (token && company_id) {
      snlistMutation.mutate({ token, company_id, letter });
    }
  }, [token, company_id]);

  if (companiesMutation.isLoading) {
    return (
      <div className="alert alert-info">
        {t("soldSn.loadingClientsUnderLetter", { letter })}...
      </div>
    );
  }

  return companies?.error ? (
    <div className="alert alert-danger">{companies.error}</div>
  ) : (
    <>
      <Modal show={showSN} onHide={() => setShowSN(false)}>
        <Modal.Header closeButton>{t("common.detail")} {showSN.sn}</Modal.Header>
        <Modal.Body>
          {showSN?.opportunity_list && (
            <span
              className={
                "badge badge-secondary badge-vendor-" +
                showSN?.opportunity_list[0]?.product.vendor_id
              }
            >
              {showSN?.opportunity_list[0]?.product.vendor_name}
            </span>
          )}
          {showSN?.opportunity_list && (
            <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable">
              <thead>
                <tr>
                  <th>{t("soldSn.opportunity")}</th>
                  <th>{t("opportunities.product")}</th>
                  <th>{t("common.expiration")}</th>
                </tr>
              </thead>
              <tbody>
                {showSN.opportunity_list.map((op) => (
                  <tr key={op.opportunity_id}>
                    <td>
                      <NavLink to={"/prilezitost/" + op.opportunity_id}>
                        {op.opportunity_id}
                      </NavLink>
                    </td>
                    <td>
                      {op.product.product_family}, {op.product.name}
                    </td>
                    <td>
                      {op.expiration_date !== "0000-00-00"
                        ? new Date(op.expiration_date).toLocaleDateString()
                        : "n/a"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Modal.Body>
      </Modal>
      {companies && companies.length > 0 && (
        <Accordion defaultActiveKey={companies[0]?.company_id}>
          {companies?.map((c) => (
            <Accordion.Item key={c.company_id} eventKey={c.company_id}>
              <Accordion.Header onClick={() => setCompanyId(c.company_id)}>
                {c.company_name}
                <div className="badge badge-warning ms-5">{c.sn_count}</div>
              </Accordion.Header>
              <Accordion.Body>
                {snlistMutation.isLoading ? (
                  <div className="alert alert-info">{t("soldSn.loadingCompanyDetail")}</div>
                ) : (
                  <>
                    <div
                      className="row"
                      style={{ maxHeight: "60vh", overflow: "auto" }}
                    >
                      {snList?.map((sn) => (
                        <div className="col-md-4 col-lg-3 my-3">
                          <div className="card h-100" key={sn}>
                            <div className="card-header">
                              <h3 className="card-title">{sn.sn}</h3>
                            </div>
                            <div className="card-body">
                              {fullName(
                                sn.opportunity_list.find(
                                  (snl) =>
                                    snl.opportunity_id ===
                                    sn.first_opportunity_id
                                )
                              )}
                            </div>
                            <div className="card-footer">
                              <button
                                className="btn btn-primary btn-sm w-100"
                                onClick={() => setShowSN(sn)}
                              >
                                {t("common.detail")}
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      )}
    </>
  );
}
